import { DASHBOARD_CONTAINER } from '../../../../types/types';
import { USER_FORM, USER_STATUS, USER_ROLES, Roles  } from '../form-portaluser-type';
import { displayUserAccessArea } from '../user-access/display-user-access';
import { dropdown, displaySelectedValue } from '../../../dropdown';

import handleNewPortalUser from './post-created-user';

/**
 * Handles creating a new portal user. This calls the addPortalUser function.
 * 
 * @returns void
 */
const CreatePortalUser = () => {
  DASHBOARD_CONTAINER.removeAttribute('style');

  dropdown(USER_STATUS, 'status', 'Status', false, true, true);
  dropdown(USER_ROLES, 'role', 'Role', false, true, true);

  const userType = USER_FORM.userRole;
  const observer = new MutationObserver((mutRecords: any) => {
    for (const { type, attributeName, target } of mutRecords) {
      if(type !== 'attributes' || attributeName !== 'data-value') {
        return;
      }

      if(target.getAttribute('data-value')) {
        let userRole = userType.getAttribute('data-value') as Roles;
        displayUserAccessArea(userRole);         
      }
    }
  });
  observer.observe(userType, { attributes: true });

  displaySelectedValue('.aafp_list-status', 'status', 'Active');

  handleNewPortalUser();
}

export default CreatePortalUser;